(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbc-showroom"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var scenes=[].slice.call(root.querySelectorAll('[data-scene]')),bar=[].slice.call(root.querySelectorAll('.mbc-bar button')),layer=root.querySelector('[data-layer]');
    var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
    function page(sc,p){
      var cells=[].slice.call(sc.querySelectorAll('.mbc-cell')),pg=sc.querySelector('[data-pager]');
      if(!pg)return;
      var size=window.innerWidth<560?6:(+pg.getAttribute('data-size')||8),pages=Math.max(1,Math.ceil(cells.length/size));
      p=Math.max(0,Math.min(pages-1,p));sc._pg=p;
      cells.forEach(function(c){var i=+c.getAttribute('data-i');c.hidden=!(i>=p*size&&i<(p+1)*size)});
      var b=pg.querySelectorAll('[data-pg]'),t=pg.querySelector('[data-pgtext]'),from=p*size+1,to=Math.min(cells.length,(p+1)*size);
      if(pages<=1){pg.setAttribute('data-single','');t.textContent=cells.length?'Touchez un article pour le voir':''}
      else{pg.removeAttribute('data-single');t.textContent='Articles '+from+' à '+to+' sur '+cells.length;b[0].disabled=p===0;b[1].disabled=p===pages-1}
    }
    function go(k){
      var key=String(k);
      scenes.forEach(function(s){s.hidden=s.getAttribute('data-scene')!==key;if(!s.hidden)page(s,0)});
      bar.forEach(function(b){b.setAttribute('aria-current',b.getAttribute('data-go')===key?'true':'false')});
      var cur=bar.filter(function(b){return b.getAttribute('aria-current')==='true'})[0];
      if(cur&&cur.scrollIntoView)try{cur.scrollIntoView({inline:'center',block:'nearest'})}catch(e){}
      try{history.replaceState(null,'',key==='entree'?'#':'#rayon-'+(+key+1))}catch(e){}
    }
    function close(){layer.innerHTML=''}
    function money(cents,cur){try{return new Intl.NumberFormat('fr-BE',{style:'currency',currency:cur||'USD'}).format(cents/100)}catch(e){return (cents/100).toFixed(2)}}
    function setCount(n){[].forEach.call(root.querySelectorAll('[data-count]'),function(el){el.textContent=n})}
    function product(btn){
      var d=btn.dataset,stock=+d.stock,max=(stock>0&&stock<99)?stock:10,q=1,multi=d.multi==='true',err='';
      function draw(){
        var tag=stock>0&&stock<=3?'<span class="tg low">Plus que '+stock+' en stock</span>':(stock>0?'<span class="tg">En stock</span>':'<span class="tg">Sur commande</span>');
        var h='<div class="veil" data-close></div><div class="sheet" role="dialog" aria-label="'+esc(d.title)+'"><button type="button" class="x" data-close aria-label="Fermer">×</button><p class="zl">'+esc(d.zone)+'</p><h3>'+esc(d.title)+'</h3>';
        h+='<div class="pic">'+(d.img?'<img src="'+esc(d.img)+'" alt="">':'')+'</div><div class="big"><span class="p">'+esc(d.price)+'</span>'+tag+'</div>';
        if(err)h+='<p class="err">'+esc(err)+'</p>';
        if(multi)h+='<a class="cta" href="'+esc(d.url)+'">Choisir une option</a>';
        else h+='<div class="qty"><button type="button" data-q="-1" aria-label="Moins">−</button><output>'+q+'</output><button type="button" data-q="1" aria-label="Plus">+</button>'+(max<10||stock>0?'<span>'+max+' maximum</span>':'')+'</div><button type="button" class="cta" data-add>Ajouter au panier</button><a class="alt" href="'+esc(d.url)+'">Voir la fiche complète</a>';
        layer.innerHTML=h+'</div>';
      }
      layer._p={q:function(n){q=Math.max(1,Math.min(max,q+n));draw()},add:function(){
        fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+d.vid,quantity:q}]})})
        .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
        .then(function(x){if(!x.ok){err=x.j.description||'Cet article n\'est plus disponible en quantité suffisante.';draw();return}cart()})
        .catch(function(){err='Connexion impossible. Réessayez.';draw()})}};
      draw();
    }
    function cart(){
      fetch(rootUrl+'cart.js').then(function(r){return r.json()}).then(function(c){
        setCount(c.item_count);
        var h='<div class="veil" data-close></div><div class="sheet" role="dialog" aria-label="Panier"><button type="button" class="x" data-close aria-label="Fermer">×</button><h3>Votre panier</h3>';
        if(!c.items.length){layer.innerHTML=h+'<p>Le panier est vide. Entrez dans un rayon et touchez un article.</p></div>';return}
        h+='<ul class="lines">';
        c.items.forEach(function(it,i){h+='<li><div class="n">'+esc(it.product_title)+(it.variant_title?' · '+esc(it.variant_title):'')+'<div style="color:#4a5875;font-size:.88rem;font-weight:400">'+money(it.final_price,c.currency)+' l\'unité</div></div><div class="mini"><button type="button" data-line="'+(i+1)+'" data-qty="'+(it.quantity-1)+'" aria-label="Retirer un">−</button><output>'+it.quantity+'</output><button type="button" data-line="'+(i+1)+'" data-qty="'+(it.quantity+1)+'" aria-label="Ajouter un">+</button></div></li>'});
        h+='</ul><div class="total"><span>Total</span><span>'+money(c.total_price,c.currency)+'</span></div><a class="cta" href="'+rootUrl+'checkout">Payer</a><a class="alt" href="'+rootUrl+'cart">Voir le panier complet</a></div>';
        layer.innerHTML=h;
      });
    }
    root.addEventListener('click',function(e){
      var t=e.target.closest('[data-go],.mbc-it,[data-close],[data-q],[data-add],[data-cart],[data-line],[data-pg]');
      if(!t||!root.contains(t))return;
      if(t.hasAttribute('data-pg')){var sc=t.closest('[data-scene]');page(sc,(sc._pg||0)+(+t.getAttribute('data-pg')))}
      else if(t.hasAttribute('data-go')){close();go(t.getAttribute('data-go'));root.scrollIntoView({block:'start',behavior:'smooth'})}
      else if(t.classList.contains('mbc-it'))product(t);
      else if(t.hasAttribute('data-close'))close();
      else if(t.hasAttribute('data-q'))layer._p.q(+t.getAttribute('data-q'));
      else if(t.hasAttribute('data-add'))layer._p.add();
      else if(t.hasAttribute('data-cart'))cart();
      else if(t.hasAttribute('data-line')){
        fetch(rootUrl+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+t.getAttribute('data-line'),quantity:Math.max(0,+t.getAttribute('data-qty'))})}).then(cart)}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
    fetch(rootUrl+'cart.js').then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){});
    var m=/^#rayon-(\d+)$/.exec(location.hash||'');
    go(m&&scenes[+m[1]]?+m[1]-1:'entree');
  }
  function boot(){[].forEach.call(document.querySelectorAll('[data-mbc]'),function(r){if(!r._mbc){r._mbc=1;init(r)}})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
